<div class="row m-0">
    <div class="col-12 p-0">
        <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen }">
            <kendo-grid [kendoGridBinding]="bottomKendoList" [reorderable]="true" [sortable]="true" [resizable]="true" [filterable]="enableFilter" class="k-resizable-grid" [pageSize]="100" [pageable]="true">
                <ng-template kendoPagerTemplate>
                    <div class="k-pager-left">
                        <kendo-pager-info></kendo-pager-info>
                    </div>
                    <div class="k-pager-right">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-input></kendo-pager-input>
                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                    </div>
                </ng-template>
                <ng-template kendoGridToolbarTemplate>
                    <div class="k-grid-toolbar-content d-flex">
                        <div class="flex-grow-1 title-container">
                            <p class="title">Workflow Step Details</p>
                        </div>
                        <div class="pagination-container">
                            <p id="lblShowDetails">Show</p>
                            <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                            </kendo-pager-page-sizes>
                            <span>Items</span>
                        </div>
                        <div class="divider-container d-none d-md-block" id="imgDivider">
                            <span></span>
                        </div>
                        <div class="icons-container">
                            <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                            <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                                <div class="icon-wrap" (click)="toggleFilter()">
                                    <i class="fa fa-filter" title="Filter" aria-hidden="true"></i>
                                    <span class="list-icon-name">Filter</span>
                                </div>
                                <div class="icon-wrap" (click)="toggleFullscreen()">
                                    <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                                    <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <kendo-grid-column title="Step Id" field="step_Id" width="60">
                </kendo-grid-column>
                <kendo-grid-column title="Workflow Stage" field="workflow_Stage" width="150">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.workflow_Stage}}" eipTooltipPosition="auto">{{dataItem.workflow_Stage}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Workflow Task" field="workflow_Status_Description" width="200">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.workflow_Status_Description}}" eipTooltipPosition="auto">{{dataItem.workflow_Status_Description}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Integration Type" field="integrationType" width="150">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.integrationType}}" eipTooltipPosition="auto">{{dataItem.integrationType}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Due days" field="due_Days" width="70">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.due_Days}}" eipTooltipPosition="auto">{{dataItem.due_Days}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Assigned To" field="workflowAssignedTo" width="150">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.workflowAssignedTo}}" eipTooltipPosition="auto">{{dataItem.workflowAssignedTo}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Assigned CC" field="workflowAssignedCc" width="150">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.workflowAssignedCc}}" eipTooltipPosition="auto">{{dataItem.workflowAssignedCc}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Workflow action" field="workflowAction" width="100">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.workflowAction}}" eipTooltipPosition="auto">{{dataItem.workflowAction}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Is Active" width="70">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.is_Active" [disabled]="true"></kendo-switch>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Action" width="60">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <i class="fa fa-pencil eip-link" title="Edit" (click)="WorkflowStepDetails_onEdit(dataItem)" style="cursor: pointer;font-size: 1.25em;" aria-hidden="true"></i>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</div>